import { render, staticRenderFns } from "./NotificationBanner.vue?vue&type=template&id=e5371804&scoped=true"
import script from "./NotificationBanner.vue?vue&type=script&lang=js"
export * from "./NotificationBanner.vue?vue&type=script&lang=js"
import style0 from "./NotificationBanner.vue?vue&type=style&index=0&id=e5371804&prod&scoped=true&lang=css"
import style1 from "./NotificationBanner.vue?vue&type=style&index=1&id=e5371804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5371804",
  null
  
)

export default component.exports